import { render, staticRenderFns } from "./AscFaultMonitorAlert.vue?vue&type=template&id=2244d2bc&"
import script from "./AscFaultMonitorAlert.vue?vue&type=script&lang=js&"
export * from "./AscFaultMonitorAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports